
import {
	Component, Vue, Prop, Emit, Watch,
} from 'vue-property-decorator';

@Component
export default class TooltipWithTextInput extends Vue {
	@Prop()
	public id!: string;

	public isTooltipShown = false;

	@Prop({ default: false })
	public isLoading!: boolean;

	@Prop({ default: false })
	public isShown!: boolean;

	@Prop({ default: false })
	public openOnClick!: boolean;

	@Prop({ default: true })
	public openOnHover!: boolean;

	@Prop({ default: 'right' })
	public position!: string;

	@Prop()
	public text!: string;

	@Watch('isShown', { })
	public watchIsShown(isShown: boolean): void {
		if (!isShown) {
			this.onCancel();
			return;
		}

		this.isTooltipShown = isShown;
	}

	@Watch('text', { immediate: true })
	public watchText(text: string): void {
		this.textModel = text;
		this.emitInput();
	}

	@Prop()
	public textSync!: string;

	public textModel = '';

	get hasHeader(): boolean {
		return !!this.$slots.header;
	}

	get isSubmitDisabled(): boolean {
		return this.textModel.length === 0;
	}

	@Emit('submit')
	public emitSubmit(): string {
		return this.textModel;
	}

	@Emit('update:textSync')
	public emitInput(): string {
		return this.textModel;
	}

	@Emit('cancel')
	public onCancel(): void {
		this.textModel = this.text;
		this.isTooltipShown = false;
	}
}
